import { DetailsGridLayout } from '~layouts';

import PolicyAdministrativeInfoCard from '../components/cards/policyAdministrativeInfoCard';
import PolicyBookingInfoCard from '../components/cards/policyBookingInfoCard';
import PolicyGeneralInfoCard from '../components/cards/policyGeneralInfoCard';
import PolicyPaymentInfoCard from '../components/cards/policyPaymentInfoCard';

interface PolicyDetailsContainerProps {
	isLoading?: boolean;
	policyId: string;
}

const PolicyDetailsContainer = ({ isLoading, policyId }: PolicyDetailsContainerProps) => {
	return (
		<DetailsGridLayout isLoading={isLoading} maxHeight='unset'>
			<PolicyGeneralInfoCard id={policyId} />
			<PolicyBookingInfoCard id={policyId} />
			<PolicyPaymentInfoCard id={policyId} />
			<PolicyAdministrativeInfoCard id={policyId} />
		</DetailsGridLayout>
	);
};

export default PolicyDetailsContainer;
